import { useState, type DragEvent, type ClipboardEvent } from "react";
import type { EditorUpload } from "./use-editor-upload";

export const useAttachmentInput = (upload: EditorUpload) => {
  const [depth, setDepth] = useState(0);
  const hasFiles = (event: DragEvent) =>
    Array.from(event.dataTransfer.types).includes("Files");
  return {
    dragging: depth > 0 && upload.available,
    onDragEnter: (event: DragEvent) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      setDepth((value) => value + 1);
    },
    onDragLeave: (event: DragEvent) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      setDepth((value) => Math.max(0, value - 1));
    },
    onDragOver: (event: DragEvent) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = upload.available ? "copy" : "none";
    },
    onDrop: (event: DragEvent) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      setDepth(0);
      upload.selectFiles(Array.from(event.dataTransfer.files));
    },
    onPaste: (event: ClipboardEvent) => {
      const files = Array.from(event.clipboardData.items)
        .filter((item) => item.kind === "file")
        .flatMap((item) => {
          const file = item.getAsFile();
          return file ? [file] : [];
        });
      if (!files.length) return;
      // Keep native text paste, including clipboard content that also has files.
      if (!event.clipboardData.getData("text/plain")) event.preventDefault();
      upload.selectFiles(files);
    },
  };
};
